import { LearningPack } from './learningPack';
import {
  FirebaseObject,
  HasCategories,
  HasKeyTakeaways,
  IsContentType,
  IsPartOfAContentGroup,
  MediaContentObject,
} from './others';

export const LESSON_TYPES = ['dailyAlux', 'ragsToRichesStory', 'sleepStory', 'specialStory', 'wisdomStory'];
export type LessonStatus = 'minimal' | 'readyToPlay';

export const POLL_MIN_OPTIONS = 3;
export const POLL_MAX_OPTIONS = 5;
// How many blank option rows a new poll starts with.
export const POLL_DEFAULT_OPTIONS = 3;

// Default title for the Social+ post created from a daily session. The admin can
// override it; the backend falls back to this template when it is left blank.
export const DEFAULT_POST_TITLE_TEMPLATE = 'Daily Alux: {lesson title}';
export const buildDefaultPostTitle = (lessonTitle?: string) =>
  lessonTitle?.trim()?.length ? `Daily Alux: ${lessonTitle.trim()}` : '';

export interface LessonPoll {
  question: string;
  options: string[];
}

export interface PollStats {
  counts: number[];
  total: number;
}

export interface Lesson
  extends FirebaseObject,
    MediaContentObject,
    HasCategories,
    IsContentType,
    IsPartOfAContentGroup,
    HasKeyTakeaways {
  progress?: number;
  purchaseId?: string;
  packInfo?: LearningPack;
  pillarType?: string;
  pillarExpertise?: string;
  status?: LessonStatus;
  isDailyLesson?: boolean;
  isRagsToRichesStory?: boolean;
  isSleepStory?: boolean;
  isSpecialStory?: boolean;
  isWisdomStory?: boolean;
  isQuestionAndAnswer?: boolean;
  otherCategories?: string[];
  tags?: string[];
  lrcTranscript?: string;
  listenReason?: string;
  postToNetworkId?: string;
  postTitle?: string;
  postContent?: string;
  amityPostId?: string;
  poll?: LessonPoll;
}
